export default __webpack_public_path__ + "static/media/orange-kush-mints.9d26a7aa.png";